export default __webpack_public_path__ + "static/media/right-drawer-error.4b824ebf.svg";